import {IAppState} from '@/interfaces/store-interfaces/app-state.interface';
import {ActionContext} from 'vuex';
import {Vue} from 'vue-property-decorator';
import {IState, RhizomeViewType} from "@/modules/Rhizome/interfaces/state.interface";
import {rhizomeResource} from "@/modules/Rhizome/resources/rhizome.resource";
import {Film} from "@/modules/Rhizome/interfaces/film.interface";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";
import ROUTE_NAME = RouterStore.ROUTE_NAME;

type StoreActionContext = ActionContext<IState, IAppState>;

export default {
  namespaced: true,

  state: {
    filmsList: [],
    viewType: RhizomeViewType.CLOUD,
    showFavorites: false,
    filterByKeyword: null,
    preActiveFilm: null,
    scaleCloud: 1,
    ordersFilmList: [],
    filterByKeywordName: '',
    errorOnRequest: false,
    kioskMode: false,
    showThemesModal: false,
    showTimeoutModal: false,
    showAboutModal: false,
    showHelpModal: false,
    controlsBelow: false,
    kioskCurrentFilmId: null
  },

  mutations: {
    setPropertyInState(state: IState, { name, value }: { name: string, value: any }) {
      Vue.set(state, name, value);
    },
  },

  actions: {
    async initRhizome({ state, commit }: StoreActionContext) {
      const keywordId = state.filterByKeyword ? state.filterByKeyword.id : null;
      const response: Film.IFilm[] = await rhizomeResource.getList(keywordId);
      commit('setPropertyInState', { name: 'filmsList', value: response });
    },

    async openRhizomeWithKeyword({ dispatch, commit }: StoreActionContext, { keyword }: { keyword: Film.IKeyword | null }) {
      commit('setPropertyInState', { name: 'filterByKeyword', value: keyword });
      await dispatch('routerStore/openPage', { routeName: ROUTE_NAME.RHIZOME_PAGE }, { root: true });
    },

    async openFilmOnRhizome({ dispatch, commit }: StoreActionContext, { filmId, query, forceRefresh }: { filmId: number | null, query: string | null, forceRefresh?: boolean }) {
      commit('setPropertyInState', { name: 'preActiveFilm', value: filmId });
      await dispatch('routerStore/openPage', { routeName: ROUTE_NAME.RHIZOME_PAGE, query, forceRefresh }, { root: true });
    },

    async openFilmModal({ commit }: StoreActionContext, { filmId }: { filmId: number | null }) {
      commit('setPropertyInState', { name: 'kioskCurrentFilmId', value: filmId });
    },

    async closeFilmModal({ commit }: StoreActionContext) {
      commit('setPropertyInState', { name: 'kioskCurrentFilmId', value: null });
    },

    openThemesModal({ commit }: StoreActionContext) {
      commit('setPropertyInState', { name: 'showThemesModal', value: true });
    },

    closeThemesModal({ commit }: StoreActionContext) {
      commit('setPropertyInState', { name: 'showThemesModal', value: false });
    },

    openTimeoutModal({ commit }: StoreActionContext) {
      commit('setPropertyInState', { name: 'showTimeoutModal', value: true });
    },

    closeTimeoutModal({ commit }: StoreActionContext) {
      commit('setPropertyInState', { name: 'showTimeoutModal', value: false });
    },

    openHelpModal({ commit }: StoreActionContext) {
      commit('setPropertyInState', { name: 'showHelpModal', value: true });
    },

    closeHelpModal({ commit }: StoreActionContext) {
      commit('setPropertyInState', { name: 'showHelpModal', value: false });
    },

    openAboutModal({ commit }: StoreActionContext) {
      commit('setPropertyInState', { name: 'showAboutModal', value: true });
    },

    closeAboutModal({ commit }: StoreActionContext) {
      commit('setPropertyInState', { name: 'showAboutModal', value: false });
    },    

    closeAllModals({ commit }: StoreActionContext) {
      commit('setPropertyInState', { name: 'kioskCurrentFilmId', value: null });
      commit('setPropertyInState', { name: 'showThemesModal', value: false });
      commit('setPropertyInState', { name: 'showTimeoutModal', value: false });
      commit('setPropertyInState', { name: 'showHelpModal', value: false });
      commit('setPropertyInState', { name: 'showAboutModal', value: false });
    }, 

    setControlsPosition({ commit }: StoreActionContext, showBelow: boolean ) {
      commit('setPropertyInState', { name: 'controlsBelow', value: showBelow })
    },
  },
};
